import * as React from 'react';
import { Body1 } from 'elc-typography';
import { ProductShadeImage } from '../common/ProductShadeImage';
import { classes } from '../../utils/Classes';
import { IShadeImages } from '../../interfaces/IShadePicker';
import { Shade } from '../../domain/entities/Shade';

export const ShadeImagesList = (props: IShadeImages) => {
    const { filteredShades } = props;
    const { onShadeSelect, selectedShade, productId, isPerfectShadeEnabled } = props.shadeConfig;
    const perfectShadeLabelClassNames = classes('product-perfect-shade-label');
    const shadeImageWrapper = classes('shade-image-wrapper');

    return filteredShades.map((shade: Shade) => (
        <div key={shade.hexVal} className={shadeImageWrapper}>
            <ProductShadeImage
                shade={shade}
                isSelected={shade.equals(selectedShade)}
                onSelect={onShadeSelect}
                productId={productId}
            />
            {isPerfectShadeEnabled && (
                <Body1 className={perfectShadeLabelClassNames}>{shade.perfectShadeLabel}</Body1>
            )}
        </div>
    ));
};

// Slider needs raw JSX array(ShadeImagesList) v.s Grid (ShadeImages) which accepts JSX component
export const ShadeImages = ({ shadeConfig, filteredShades }: IShadeImages) => (
    <>{ShadeImagesList({ filteredShades, shadeConfig })}</>
);
